import { BreachItem } from "../components/BreachItem";
import { StatsCard } from "../components/StatsCard";

const breachMetrics = [
  {
    label: "Total Breaches Detected",
    value: 123,
    trend: {
      direction: "up" as const,
      value: 15,
    },
  },
  {
    label: "Unresolved Breaches (90 days)",
    value: 12,
    trend: {
      direction: "up" as const,
      value: 1,
    },
  },
  {
    label: "Vendors with Breaches",
    value: 17,
  },
];

export function BreachHistoryTab() {
  return (
    <div className="space-y-4">
      {/* Metrics */}
      <div className="grid grid-cols-3 gap-4">
        {breachMetrics.map((metric, index) => (
          <StatsCard key={index} label={metric.label} value={metric.value} trend={metric.trend} />
        ))}
      </div>

      {/* Breach History List */}
      <div>
        <h3 className="font-inter text-[14px] font-medium leading-[20px] tracking-[0%] text-[#71717A] mb-4">Breach History Across Vendors</h3>
        <div className="space-y-4 max-h-[600px] pr-2">
          <BreachItem
            vendor="GitHub Copilot"
            icon="github"
            description="Recent Black Basta ransomware attack prompts a security review of cloud provider, Nimbus Systems. Initial risk score was Low, now reassessed to Medium due to potential supply chain vulnerabilities. Additional investigation revealed multiple security concerns including outdated authentication protocols, insufficient access controls, and lack of encryption in transit. The vendor has been notified and a comprehensive security audit is currently underway to address these critical issues."
            risk="Low"
            date="Oct 15, 2025"
            sources={[
              {
                url: "https://nvd.nist.gov/vuln/detail/CVE-2024-1234",
                domain: "nvd.nist.gov",
                indices: [3, 4],
                status: "success",
              },
              {
                url: "https://nvd.nist.gov/vuln/detail/CVE-2024-1234",
                domain: "nvd.nist.gov",
                indices: [11],
                status: "info",
              },
              {
                url: "https://nvd.nist.gov/vuln/detail/CVE-2024-1234",
                domain: "nvd.nist.gov",
                indices: [6],
                status: "success",
              },
            ]}
          />
          <BreachItem
            vendor="Google Drive"
            icon="google"
            description="Recent supply chain attack on SolarWind triggers reassessment of network security vendor, Aurora Networks. Initial risk score was Low, now reassessed to Medium due to outdated encryption protocols."
            risk="Low"
            date="Sep 28, 2025"
            sources={[
              {
                url: "https://nvd.nist.gov/vuln/detail/CVE-2024-1234",
                domain: "nvd.nist.gov",
                indices: [7, 8],
                status: "warning",
              },
              { url: "https://nvd.nist.gov/vuln/detail/CVE-2024-1234", domain: "nvd.nist.gov", indices: [12], status: "info" },
            ]}
          />
          <BreachItem
            vendor="Microsoft Teams"
            icon="microsoft"
            description="Recent data breach at Target necessitates reassessment of payment processor, Centaur Payments. Initial risk score was Low, now reassessed to Medium due to insufficient data encryption."
            risk="Medium"
            date="Sep 12, 2025"
            sources={[
              {
                url: "https://nvd.nist.gov/vuln/detail/CVE-2024-1234",
                domain: "nvd.nist.gov",
                indices: [9],
                status: "success",
              },
            ]}
          />
          <BreachItem
            vendor="OpenAI API"
            icon="openai"
            description="Recent ransomware attack on Colonial Pipeline prompts reassessment of cybersecurity vendor, Bastion Security. Initial risk score was Low, now reassessed to Medium due to inadequate threat detection."
            risk="Low"
            date="Aug 30, 2025"
            sources={[
              {
                url: "https://nvd.nist.gov/vuln/detail/CVE-2024-1234",
                domain: "nvd.nist.gov",
                indices: [2],
                status: "info",
              },
              { url: "https://nvd.nist.gov/vuln/detail/CVE-2024-1234", domain: "nvd.nist.gov", indices: [5], status: "info" },
            ]}
          />
          <BreachItem
            vendor="Google Drive"
            icon="google"
            description="Recent phishing campaign targeting Microsoft 365 users triggers reassessment of email security vendor, Ironclad Defense. Initial risk score was Low, now reassessed to Medium due to evolving threat landscape."
            risk="Low"
            date="Aug 18, 2025"
            sources={[
              {
                url: "https://nvd.nist.gov/vuln/detail/CVE-2024-1234",
                domain: "nvd.nist.gov",
                indices: [1],
                status: "warning",
              },
              {
                url: "https://nvd.nist.gov/vuln/detail/CVE-2024-1234",
                domain: "nvd.nist.gov",
                indices: [10],
                status: "success",
              },
            ]}
          />
        </div>
      </div>
    </div>
  );
}
